/**
 * @param {Object} item
 * @returns {Object | undefined} An object containing the changed props
 */
const getChangedProps = item => {
  if (item.id === '60333850b') {
    // replace any old trolley w doors with correct id
    return {
      id: 'S49275286',
    };
  } else if (
    [
      '40033763_insert',
      '70033766_insert',
      '10482946_insert',
      '70482948_insert',
      '50482949_insert',
      '30381593_insert',
      '50381592_insert',
      '40483973_insert',
      '60483972_insert',
    ].some(id => item.id === id)
  ) {
    // IVAR cabinets are now the same product as inserts and non-inserts
    // and their position in the section have corrected slightly
    return {
      id: item.id.replace('_insert', ''),
      x: item.x + 15,
    };
  }
};

/**
 * @param {Object} item
 * @returns {Object} A corrected version of the item
 */
const getCorrectedItem = item => {
  return {
    ...item,
    ...getChangedProps(item),
    items: [...(item.items?.map(getCorrectedItem) || [])],
  };
};

/**
 * Goes through a PAC coming from a VPC and replaces any products that have
 * changed since its creation.
 * @param {Object} pac
 * @returns {Object} A corrected version of the PAC
 */
export default function fixVPC(pac) {
  const adjustedPAC = {
    ...pac,
    model: {
      ...pac.model,
      items: [...pac.model.items.map(getCorrectedItem)],
    },
    isVpc: true,
  };

  return adjustedPAC;
}
